var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPxPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.026.592 1.377 1.377a2 2 0 0 1 0 2.829L4.5 15.702a1 1 0 0 1-.705.293L1.012 16c-.552 0-1-.446-1.002-.998l-.007-2.798a1 1 0 0 1 .293-.71L11.198.592a2 2 0 0 1 2.828 0Zm-5.174 5.15L2.4 12.194a1 1 0 0 0-.293.714l.003.492a.5.5 0 0 0 .503.497l.483-.003a1 1 0 0 0 .7-.293l6.457-6.458-1.401-1.401Zm4.462-3.06a.991.991 0 0 0-1.402 0l-1.659 1.659 1.401 1.401 1.66-1.658a.991.991 0 0 0 .082-1.309Z",
    fill: "#6B6E85",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPxPencil);
export default __webpack_public_path__ + "static/media/px-pencil.6446a19f34703c72229d60d60119e2ee.svg";
export { ForwardRef as ReactComponent };